// noScratches: "新品同等傷なし",
// someScratches: "若干傷あり",
// noticeableScratches: "目立つ傷あり",
// crackedScreen: "画面割れ",aaaa

export const PurchaseData = [
  {
    id: 17,
    series: "iPhone17シリーズ",
    model: [
      {
        id: 171,
        name: "iphone17",
        spec: [
          {
            id: 1,
            gb: "256GB",
            noScratches: "最大100,000円",
            someScratches: "最大97,000円",
            noticeableScratches: "最大87,000円",
            crackedScreen: "最大58,000円",
          },
          {
            id: 2,
            gb: "512GB",
            noScratches: "最大117,500円",
            someScratches: "最大114,500円",
            noticeableScratches: "最大103,500円",
            crackedScreen: "最大65,000円",
          },
        ],
      },
      {
        id: 172,
        name: "iphoneAir",
        spec: [
          {
            id: 1,
            gb: "256GB",
            noScratches: "最大121,100円",
            someScratches: "最大100,000円",
            noticeableScratches: "最大95,000円",
            crackedScreen: "最大56,000円",
          },
          {
            id: 2,
            gb: "512GB",
            noScratches: "最大137,000円",
            someScratches: "最大102,500円",
            noticeableScratches: "最大98,000円",
            crackedScreen: "最大60,000円",
          },
          {
            id: 3,
            gb: "1TB",
            noScratches: "最大150,000円",
            someScratches: "最大124,500円",
            noticeableScratches: "最大107,500円",
            crackedScreen: "最大65,000円",
          },
        ],
      },
      {
        id: 173,
        name: "iphone17e",
        spec: [
          {
            id: 1,
            gb: "256GB",
            noScratches: "最大74,000円",
            someScratches: "最大67,000円",
            noticeableScratches: "最大61,000円",
            crackedScreen: "最大38,000円",
          },
          {
            id: 2,
            gb: "512GB",
            noScratches: "最大87,600円",
            someScratches: "最大82,000円",
            noticeableScratches: "最大76,000円",
            crackedScreen: "最大40,000円",
          },
        ],
      },
      {
        id: 174,
        name: "iphone17 Pro",
        spec: [
          {
            id: 1,
            gb: "256GB",
            noScratches: "最大168,000円",
            someScratches: "最大153,000円",
            noticeableScratches: "最大125,000円",
            crackedScreen: "最大80,000円",
          },
          {
            id: 2,
            gb: "512GB",
            noScratches: "最大200,000円",
            someScratches: "最大165,000円",
            noticeableScratches: "最大156,000円",
            crackedScreen: "最大89,000円",
          },
          {
            id: 3,
            gb: "1TB",
            noScratches: "最大220,000円",
            someScratches: "最大188,000円",
            noticeableScratches: "最大179,000円",
            crackedScreen: "最大100,000円",
          },
        ],
      },
      {
        id: 175,
        name: "iphone17 Pro Max",
        spec: [
          {
            id: 1,
            gb: "256GB",
            noScratches: "最大181,000円",
            someScratches: "最大155,000円",
            noticeableScratches: "最大135,000円",
            crackedScreen: "最大88,000円",
          },
          {
            id: 2,
            gb: "512GB",
            noScratches: "最大206,000円",
            someScratches: "最大170,000円",
            noticeableScratches: "最大160,100円",
            crackedScreen: "最大100,000円",
          },
          {
            id: 3,
            gb: "1TB",
            noScratches: "最大249,000円",
            someScratches: "最大191,000円",
            noticeableScratches: "最大184,000円",
            crackedScreen: "最大106,000円",
          },
          {
            id: 4,
            gb: "2TB",
            noScratches: "最大271,000円",
            someScratches: "最大217,000円",
            noticeableScratches: "最大207,000円",
            crackedScreen: "最大120,000円",
          },
        ],
      },
    ],
  },
{
  id: 16,
  series: "iPhone16シリーズ",
  model: [
    {
      id: 161,
      name: "iphone16",
      spec: [
        {
          id: 1,
          gb: "128GB",
          noScratches: "最大85,000円",
          someScratches: "最大76,000円",
          noticeableScratches: "最大69,500円",
          crackedScreen: "最大45,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大98,000円",
          someScratches: "最大84,000円",
          noticeableScratches: "最大80,000円",
          crackedScreen: "最大53,000円",
        },
        {
          id: 3,
          gb: "512GB",
          noScratches: "最大104,000円",
          someScratches: "最大91,000円",
          noticeableScratches: "最大84,000円",
          crackedScreen: "最大56,000円",
        },
      ],
    },
    {
      id: 165,
      name: "iphone16e",
      spec: [
        {
          id: 1,
          gb: "128GB",
          noScratches: "最大58,000円",
          someScratches: "最大54,000円",
          noticeableScratches: "最大48,000円",
          crackedScreen: "最大37,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大66,000円",
          someScratches: "最大62,000円",
          noticeableScratches: "最大56,000円",
          crackedScreen: "最大42,000円",
        },
        {
          id: 3,
          gb: "512GB",
          noScratches: "最大71,000円",
          someScratches: "最大67,000円",
          noticeableScratches: "最大64,000円",
          crackedScreen: "最大48,000円",
        },
      ],
    },
    {
      id: 162,
      name: "iphone16 plus",
      spec: [
        {
          id: 1,
          gb: "128GB",
          noScratches: "最大92,000円",
          someScratches: "最大82,000円",
          noticeableScratches: "最大70,500円",
          crackedScreen: "最大48,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大103,000円",
          someScratches: "最大88,000円",
          noticeableScratches: "最大81,000円",
          crackedScreen: "最大56,000円",
        },
        {
          id: 3,
          gb: "512GB",
          noScratches: "最大111,000円",
          someScratches: "最大90,000円",
          noticeableScratches: "最大84,000円",
          crackedScreen: "最大59,000円",
        },
      ],
    },
    {
      id: 163,
      name: "iphone16 Pro",
      spec: [
        {
          id: 1,
          gb: "128GB",
          noScratches: "最大132,000円",
          someScratches: "最大98,500円",
          noticeableScratches: "最大88,000円",
          crackedScreen: "最大63,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大151,000円",
          someScratches: "最大113,000円",
          noticeableScratches: "最大108,000円",
          crackedScreen: "最大72,000円",
        },
        {
          id: 3,
          gb: "512GB",
          noScratches: "最大179,000円",
          someScratches: "最大115,500円",
          noticeableScratches: "最大105,500円",
          crackedScreen: "最大78,000円",
        },
        {
          id: 4,
          gb: "1TB",
          noScratches: "最大194,000円",
          someScratches: "最大122,000円",
          noticeableScratches: "最大112,500円",
          crackedScreen: "最大83,000円",
        },
      ],
    },
    {
      id: 164,
      name: "iphone16 Pro Max",
      spec: [
        {
          id: 1,
          gb: "256GB",
          noScratches: "最大161,000円",
          someScratches: "最大127,500円",
          noticeableScratches: "最大119,500円",
          crackedScreen: "最大77,000円",
        },
        {
          id: 2,
          gb: "512GB",
          noScratches: "最大190,000円",
          someScratches: "最大139,500円",
          noticeableScratches: "最大131,000円",
          crackedScreen: "最大85,000円",
        },
        {
          id: 3,
          gb: "1TB",
          noScratches: "最大216,000円",
          someScratches: "最大144,000円",
          noticeableScratches: "最大135,500円",
          crackedScreen: "最大90,000円",
        },
      ],
    },
  ],
},
{
  id: 15,
  series: "iPhone15シリーズ",
  model: [
    {
      id: 151,
      name: "iphone15",
      spec: [
        {
          id: 1,
          gb: "128GB",
          noScratches: "最大73,000円",
          someScratches: "最大60,000円",
          noticeableScratches: "最大56,000円",
          crackedScreen: "最大37,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大81,000円",
          someScratches: "最大70,000円",
          noticeableScratches: "最大59,500円",
          crackedScreen: "最大41,000円",
        },
        {
          id: 3,
          gb: "512GB",
          noScratches: "最大89,000円",
          someScratches: "最大73,000円",
          noticeableScratches: "最大67,000円",
          crackedScreen: "最大44,000円",
        },
      ],
    },
    {
      id: 152,
      name: "iphone15 plus",
      spec: [
        {
          id: 1,
          gb: "128GB",
          noScratches: "最大85,000円",
          someScratches: "最大56,000円",
          noticeableScratches: "最大52,000円",
          crackedScreen: "最大36,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大95,000円",
          someScratches: "最大61,000円",
          noticeableScratches: "最大56,000円",
          crackedScreen: "最大40,000円",
        },
        {
          id: 3,
          gb: "512GB",
          noScratches: "最大101,000円",
          someScratches: "最大66,000円",
          noticeableScratches: "最大59,000円",
          crackedScreen: "最大45,000円",
        },
      ],
    },
    {
      id: 153,
      name: "iphone15 Pro",
      spec: [
        {
          id: 1,
          gb: "128GB",
          noScratches: "最大110,000円",
          someScratches: "最大72,000円",
          noticeableScratches: "最大65,000円",
          crackedScreen: "最大44,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大123,000円",
          someScratches: "最大78,000円",
          noticeableScratches: "最大71,500円",
          crackedScreen: "最大48,000円",
        },
        {
          id: 3,
          gb: "512GB",
          noScratches: "最大133,000円",
          someScratches: "最大87,000円",
          noticeableScratches: "最大79,000円",
          crackedScreen: "最大51,000円",
        },
        {
          id: 4,
          gb: "1TB",
          noScratches: "最大143,000円",
          someScratches: "最大90,000円",
          noticeableScratches: "最大84,000円",
          crackedScreen: "最大54,000円",
        },
      ],
    },
    {
      id: 154,
      name: "iphone15 Pro Max",
      spec: [
        {
          id: 1,
          gb: "256GB",
          noScratches: "最大137,000円",
          someScratches: "最大94,000円",
          noticeableScratches: "最大85,000円",
          crackedScreen: "最大56,000円",
        },
        {
          id: 2,
          gb: "512GB",
          noScratches: "最大150,000円",
          someScratches: "最大101,000円",
          noticeableScratches: "最大90,000円",
          crackedScreen: "最大61,000円",
        },
        {
          id: 3,
          gb: "1TB",
          noScratches: "最大155,000円",
          someScratches: "最大110,000円",
          noticeableScratches: "最大94,500円",
          crackedScreen: "最大63,000円",
        },
      ],
    },
  ],
},
{
  id: 14,
  series: "iPhone14シリーズ",
  model: [
    {
      id: 141,
      name: "iphone14",
      spec: [
        {
          id: 1,
          gb: "128GB",
          noScratches: "最大61,000円",
          someScratches: "最大42,000円",
          noticeableScratches: "最大37,000円",
          crackedScreen: "最大27,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大69,000円",
          someScratches: "最大47,000円",
          noticeableScratches: "最大43,000円",
          crackedScreen: "最大30,000円",
        },
        {
          id: 3,
          gb: "512GB",
          noScratches: "最大70,000円",
          someScratches: "最大51,000円",
          noticeableScratches: "最大46,000円",
          crackedScreen: "最大31,000円",
        },
      ],
    },
    {
      id: 142,
      name: "iphone14 plus",
      spec: [
        {
          id: 1,
          gb: "128GB",
          noScratches: "最大55,000円",
          someScratches: "最大48,000円",
          noticeableScratches: "最大44,000円",
          crackedScreen: "最大28,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大58,000円",
          someScratches: "最大50,000円",
          noticeableScratches: "最大46,000円",
          crackedScreen: "最大31,000円",
        },
        {
          id: 3,
          gb: "512GB",
          noScratches: "最大60,000円",
          someScratches: "最大53,000円",
          noticeableScratches: "最大47,500円",
          crackedScreen: "最大34,000円",
        },
      ],
    },
    {
      id: 143,
      name: "iphone14 Pro",
      spec: [
        {
          id: 1,
          gb: "128GB",
          noScratches: "最大64,000円",
          someScratches: "最大56,000円",
          noticeableScratches: "最大52,000円",
          crackedScreen: "最大37,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大68,000円",
          someScratches: "最大60,000円",
          noticeableScratches: "最大55,000円",
          crackedScreen: "最大39,000円",
        },
        {
          id: 3,
          gb: "512GB",
          noScratches: "最大72,000円",
          someScratches: "最大64,000円",
          noticeableScratches: "最大59,000円",
          crackedScreen: "最大42,000円",
        },
        {
          id: 4,
          gb: "1TB",
          noScratches: "最大75,000円",
          someScratches: "最大67,000円",
          noticeableScratches: "最大63,000円",
          crackedScreen: "最大46,000円",
        },
      ],
    },
    {
      id: 144,
      name: "iphone14 Pro Max",
      spec: [
        {
          id: 1,
          gb: "128GB",
          noScratches: "最大79,000円",
          someScratches: "最大69,000円",
          noticeableScratches: "最大59,000円",
          crackedScreen: "最大42,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大84,000円",
          someScratches: "最大74,000円",
          noticeableScratches: "最大63,000円",
          crackedScreen: "最大44,000円",
        },
        {
          id: 3,
          gb: "512GB",
          noScratches: "最大87,000円",
          someScratches: "最大81,000円",
          noticeableScratches: "最大68,000円",
          crackedScreen: "最大46,000円",
        },
        {
          id: 4,
          gb: "1TB",
          noScratches: "最大90,000円",
          someScratches: "最大85,000円",
          noticeableScratches: "最大73,000円",
          crackedScreen: "最大49,000円",
        },
      ],
    },
  ],
},
{
    id: 3,
    series: "iPhoneSE第3世代",
    model: [
      {
        id: 31,
        name: "iPhoneSE第3世代",
        spec: [
          {
            id: 1,
            gb: "64GB",
            noScratches: "最大28,000円",
            someScratches: "最大17,000円",
            noticeableScratches: "最大12,000円",
            crackedScreen: "最大7,000円",
          },
          {
            id: 2,
            gb: "128GB",
            noScratches: "最大29,000円",
            someScratches: "最大21,000円",
            noticeableScratches: "最大15,000円",
            crackedScreen: "最大10,500円",
          },
          {
            id: 3,
            gb: "256GB",
            noScratches: "最大30,000円",
            someScratches: "最大24,000円",
            noticeableScratches: "最大18,000円",
            crackedScreen: "最大13,500円",
          },
        ],
      },
    ],
  },
{
  id: 13,
  series: "iPhone13シリーズ",
  model: [
    {
      id: 131,
      name: "iphone13",
      spec: [
        {
          id: 1,
          gb: "128GB",
          noScratches: "最大39,000円",
          someScratches: "最大35,000円",
          noticeableScratches: "最大27,000円",
          crackedScreen: "最大21,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大43,000円",
          someScratches: "最大38,000円",
          noticeableScratches: "最大30,000円",
          crackedScreen: "最大22,000円",
        },
        {
          id: 3,
          gb: "512GB",
          noScratches: "最大47,000円",
          someScratches: "最大42,000円",
          noticeableScratches: "最大33,000円",
          crackedScreen: "最大24,000円",
        },
      ],
    },
    {
      id: 132,
      name: "iphone13 mini",
      spec: [
        {
          id: 1,
          gb: "128GB",
          noScratches: "最大30,000円",
          someScratches: "最大26,000円",
          noticeableScratches: "最大24,000円",
          crackedScreen: "最大19,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大41,000円",
          someScratches: "最大37,000円",
          noticeableScratches: "最大29,500円",
          crackedScreen: "最大22,000円",
        },
        {
          id: 3,
          gb: "512GB",
          noScratches: "最大46,000円",
          someScratches: "最大41,000円",
          noticeableScratches: "最大36,500円",
          crackedScreen: "最大23,000円",
        },
      ],
    },
    {
      id: 133,
      name: "iphone13 Pro",
      spec: [
        {
          id: 1,
          gb: "128GB",
          noScratches: "最大47,000円",
          someScratches: "最大42,000円",
          noticeableScratches: "最大38,000円",
          crackedScreen: "最大26,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大53,000円",
          someScratches: "最大49,000円",
          noticeableScratches: "最大41,500円",
          crackedScreen: "最大28,000円",
        },
        {
          id: 3,
          gb: "512GB",
          noScratches: "最大56,000円",
          someScratches: "最大51,000円",
          noticeableScratches: "最大42,500円",
          crackedScreen: "最大29,000円",
        },
        {
          id: 4,
          gb: "1TB",
          noScratches: "最大57,000円",
          someScratches: "最大52,000円",
          noticeableScratches: "最大45,000円",
          crackedScreen: "最大31,000円",
        },
      ],
    },
    {
      id: 134,
      name: "iphone13 Pro Max",
      spec: [
        {
          id: 1,
          gb: "128GB",
          noScratches: "最大66,000円",
          someScratches: "最大59,000円",
          noticeableScratches: "最大49,000円",
          crackedScreen: "最大33,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大68,000円",
          someScratches: "最大61,000円",
          noticeableScratches: "最大50,000円",
          crackedScreen: "最大34,000円",
        },
        {
          id: 3,
          gb: "512GB",
          noScratches: "最大70,000円",
          someScratches: "最大63,000円",
          noticeableScratches: "最大51,500円",
          crackedScreen: "最大36,000円",
        },
        {
          id: 4,
          gb: "1TB",
          noScratches: "最大71,000円",
          someScratches: "最大64,000円",
          noticeableScratches: "最大53,000円",
          crackedScreen: "最大38,000円",
        },
      ],
    },
  ],
},
{
  id: 12,
  series: "iPhone12シリーズ",
  model: [
    {
      id: 121,
      name: "iphone12",
      spec: [
        {
          id: 1,
          gb: "64GB",
          noScratches: "最大24,000円",
          someScratches: "最大21,000円",
          noticeableScratches: "最大18,000円",
          crackedScreen: "最大11,000円",
        },
        {
          id: 2,
          gb: "128GB",
          noScratches: "最大27,000円",
          someScratches: "最大24,000円",
          noticeableScratches: "最大20,000円",
          crackedScreen: "最大12,000円",
        },
        {
          id: 3,
          gb: "256GB",
          noScratches: "最大29,000円",
          someScratches: "最大26,000円",
          noticeableScratches: "最大22,000円",
          crackedScreen: "最大13,000円",
        },
      ],
    },
    {
      id: 122,
      name: "iphone12 mini",
      spec: [
        {
          id: 1,
          gb: "64GB",
          noScratches: "最大20,000円",
          someScratches: "最大17,000円",
          noticeableScratches: "最大15,000円",
          crackedScreen: "最大10,000円",
        },
        {
          id: 2,
          gb: "128GB",
          noScratches: "最大21,000円",
          someScratches: "最大18,000円",
          noticeableScratches: "最大16,000円",
          crackedScreen: "最大12,000円",
        },
        {
          id: 3,
          gb: "256GB",
          noScratches: "最大22,000円",
          someScratches: "最大19,000円",
          noticeableScratches: "最大17,000円",
          crackedScreen: "最大13,000円",
        },
      ],
    },
    {
      id: 123,
      name: "iphone12 Pro",
      spec: [
        {
          id: 1,
          gb: "128GB",
          noScratches: "最大32,000円",
          someScratches: "最大28,000円",
          noticeableScratches: "最大25,000円",
          crackedScreen: "最大16,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大35,000円",
          someScratches: "最大32,000円",
          noticeableScratches: "最大27,000円",
          crackedScreen: "最大17,000円",
        },
        {
          id: 3,
          gb: "512GB",
          noScratches: "最大37,000円",
          someScratches: "最大33,000円",
          noticeableScratches: "最大29,000円",
          crackedScreen: "最大18,000円",
        },
      ],
    },
    {
      id: 124,
      name: "iphone12 Pro Max",
      spec: [
        {
          id: 1,
          gb: "128GB",
          noScratches: "最大38,000円",
          someScratches: "最大37,000円",
          noticeableScratches: "最大32,000円",
          crackedScreen: "最大22,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大47,000円",
          someScratches: "最大42,000円",
          noticeableScratches: "最大35,000円",
          crackedScreen: "最大24,000円",
        },
        {
          id: 3,
          gb: "512GB",
          noScratches: "最大49,000円",
          someScratches: "最大46,000円",
          noticeableScratches: "最大39,000円",
          crackedScreen: "最大26,000円",
        },
      ],
    },
  ],
},
{
    id: 2,
    series: "iPhoneSE第2世代",
    model: [
      {
        id: 21,
        name: "iPhoneSE第2世代",
        spec: [
          {
            id: 1,
            gb: "64GB",
            noScratches: "最大9,500円",
            someScratches: "最大8,000円",
            noticeableScratches: "最大5,000円",
            crackedScreen: "最大2,000円",
          },
          {
            id: 2,
            gb: "128GB",
            noScratches: "最大12,000円",
            someScratches: "最大10,000円",
            noticeableScratches: "最大7,000円",
            crackedScreen: "最大4,000円",
          },
          {
            id: 3,
            gb: "256GB",
            noScratches: "最大13,500円",
            someScratches: "最大12,000円",
            noticeableScratches: "最大9,000円",
            crackedScreen: "最大4,500円",
          },
        ],
      },
    ],
  },
{
  id: 11,
  series: "iPhone11シリーズ",
  model: [
    {
      id: 111,
      name: "iphone11",
      spec: [
        {
          id: 1,
          gb: "64GB",
          noScratches: "最大18,000円",
          someScratches: "最大16,000円",
          noticeableScratches: "最大14,000円",
          crackedScreen: "最大11,000円",
        },
        {
          id: 2,
          gb: "128GB",
          noScratches: "最大21,000円",
          someScratches: "最大19,000円",
          noticeableScratches: "最大17,000円",
          crackedScreen: "最大12,000円",
        },
        {
          id: 3,
          gb: "256GB",
          noScratches: "最大24,000円",
          someScratches: "最大21,000円",
          noticeableScratches: "最大18,000円",
          crackedScreen: "最大13,000円",
        },
      ],
    },
    {
      id: 112,
      name: "iphone11 Pro",
      spec: [
        {
          id: 1,
          gb: "64GB",
          noScratches: "最大22,000円",
          someScratches: "最大19,000円",
          noticeableScratches: "最大16,000円",
          crackedScreen: "最大12,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大24,000円",
          someScratches: "最大21,000円",
          noticeableScratches: "最大18,000円",
          crackedScreen: "最大13,000円",
        },
        {
          id: 3,
          gb: "512GB",
          noScratches: "最大25,000円",
          someScratches: "最大22,000円",
          noticeableScratches: "最大19,000円",
          crackedScreen: "最大15,000円",
        },
      ],
    },
    {
      id: 113,
      name: "iphone11 Pro Max",
      spec: [
        {
          id: 1,
          gb: "64GB",
          noScratches: "最大26,000円",
          someScratches: "最大24,000円",
          noticeableScratches: "最大19,000円",
          crackedScreen: "最大15,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大27,000円",
          someScratches: "最大25,000円",
          noticeableScratches: "最大20,000円",
          crackedScreen: "最大17,000円",
        },
        {
          id: 3,
          gb: "512GB",
          noScratches: "最大30,000円",
          someScratches: "最大27,000円",
          noticeableScratches: "最大21,000円",
          crackedScreen: "最大19,000円",
        },
      ],
    },
  ],
},
{
  id: 10,
  series: "iPhoneXシリーズ",
  model: [
    {
      id: 101,
      name: "iphoneX",
      spec: [
        {
          id: 1,
          gb: "64GB",
          noScratches: "最大10,000円",
          someScratches: "最大9,000円",
          noticeableScratches: "最大8,000円",
          crackedScreen: "最大6,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大12,000円",
          someScratches: "最大10,000円",
          noticeableScratches: "最大9,000円",
          crackedScreen: "最大7,000円",
        },
      ],
    },
    {
      id: 102,
      name: "iphoneXR",
      spec: [
        {
          id: 1,
          gb: "64GB",
          noScratches: "最大14,000円",
          someScratches: "最大12,000円",
          noticeableScratches: "最大10,000円",
          crackedScreen: "最大7,000円",
        },
        {
          id: 2,
          gb: "128GB",
          noScratches: "最大15,000円",
          someScratches: "最大13,000円",
          noticeableScratches: "最大11,000円",
          crackedScreen: "最大8,000円",
        },
        {
          id: 3,
          gb: "256GB",
          noScratches: "最大16,000円",
          someScratches: "最大14,000円",
          noticeableScratches: "最大12,000円",
          crackedScreen: "最大9,000円",
        },
      ],
    },
    {
      id: 103,
      name: "iphoneXS",
      spec: [
        {
          id: 1,
          gb: "64GB",
          noScratches: "最大14,500円",
          someScratches: "最大12,000円",
          noticeableScratches: "最大9,000円",
          crackedScreen: "最大7,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大15,500円",
          someScratches: "最大14,000円",
          noticeableScratches: "最大11,000円",
          crackedScreen: "最大9,000円",
        },
        {
          id: 3,
          gb: "512GB",
          noScratches: "最大16,500円",
          someScratches: "最大15,000円",
          noticeableScratches: "最大12,000円",
          crackedScreen: "最大10,000円",
        },
      ],
    },
    {
      id: 104,
      name: "iphoneXSMax",
      spec: [
        {
          id: 1,
          gb: "64GB",
          noScratches: "最大18,000円",
          someScratches: "最大16,000円",
          noticeableScratches: "最大14,000円",
          crackedScreen: "最大11,000円",
        },
        {
          id: 2,
          gb: "256GB",
          noScratches: "最大21,000円",
          someScratches: "最大18,000円",
          noticeableScratches: "最大16,000円",
          crackedScreen: "最大12,000円",
        },
        {
          id: 3,
          gb: "512GB",
          noScratches: "最大23,000円",
          someScratches: "最大20,000円",
          noticeableScratches: "最大18,000円",
          crackedScreen: "最大13,000円",
          },
        ],
      },
    ],
  },
];

export const FAQData = [
  {
    genre: "査定について",
    qa: [
      {
        q: "掲載価格について",
        a: "掲載価格は2026年6月時点での最大買取価格です。市場価格変動により予告なく変更になる場合がございます。公式LINEにてお気軽にお尋ねください。",
      },
      {
        q: "査定時間はどのくらいですか？",
        a: "最短2日～3日以内には査定を行います。混み合ってる場合は1週間ほどお時間頂く場合もございます。",
      },
      {
        q: "複数台の買取で金額は変わりますか？",
        a: "複数台の買取の場合でも原則買取金額は変わりませんが、台数や内容に応じてご相談ください。",
      },
      {
        q: "一度に何台まで買取可能ですか？",
        a: "原則お一人様5台までの買取とさせて頂いております。それ以上の場合はご相談ください",
      },
      {
        q: "掲載されている最大買取価格の条件はありますか？",
        a: "掲載価格は各ランクにおける外観基準での最大買取価格となります。端末状態・バッテリー劣化・交換歴の有無・ネットワーク利用制限などによって査定価格が変動する場合がございます。",
      },
      {
        q: "箱や付属品がなくても買取可能ですか？",
        a: "箱や付属品等がなくても買い取りができなかったり減額対象になることはありません。",
      },
      {
        q: "個人情報（データ）が入った端末は買取可能ですか？",
        a: "個人情報が入っているものの買取は出来ません。",
      },
      {
        q: "端末代金が支払い途中でも買取可能ですか？",
        a: "割賦代金支払い途中であっても問題なく買取可能ですが、赤ロム端末（ネットワーク利用制限が×のもの）に関しては買取出来かねます。",
      },
      {
        q: "買取出来ない端末はありますか？",
        a: "基本的にiPhoneであれば買取可能ですが、アクティベーションロックがかかっている端末、iPhoneを探すがオフにできない端末は買取不可能です。",
      },
      {
        q: "未成年の買取受付は出来ますか？",
        a: "18歳以上の方で所定の本人確認書類のアップロードが頂ける方のみ買取可能となっております。",
      },
    ],
  },
  {
    genre: "送料について",
    qa: [
      {
        q: "送料はかかりますか？",
        a: "ご安心ください。送料に関してお客様の負担はございません。",
      },
      {
        q: "査定キャンセルした場合の返送料はかかりますか？",
        a: "査定をキャンセル頂いた場合も返送料などは頂いておりませんのでご安心ください。",
      },
    ],
  },
  {
    genre: "郵送について",
    qa: [
      {
        q: "回収方法を教えてください",
        a: "査定フォームに回答頂いたご希望の集荷日時にクロネコヤマトの配達員が引き取りにお伺いします。査定希望の端末は必ず初期化をしてお渡しください。",
      },
      {
        q: "SIMカードを入れたまま送った場合は？",
        a: "SIMカードが入ったまま送って頂くことも可能ですが、弊社到着時にSIMカードが入っていた場合はこちらにて破棄させて頂きます。",
      },
    ],
  },
  {
    genre: "支払い方法について",
    qa: [
      {
        q: "査定金額の入金方法について？",
        a: "お客様の指定口座にお振込みさせて頂きます。",
      },
      {
        q: "銀行の名義が違う場合、振り込み可能ですか？",
        a: "お振込みの銀行口座に関しましては、アップロード頂く本人確認書類と同名義の口座のみお振込み可能になります。",
      },
      {
        q: "本人確認書類は何が必要ですか？",
        a: "免許証（裏面に住所がある場合は公安印が必要）・健康保険証・学生証（高校生不可）・日本国パスポート（2020年2月3日以前に申請し、日本国で発行され現住所の記載があるもの）・在留カード（住居欄が空欄のものは不可。顔写真があるもの）",
      },
    ],
  },
];
